/** @format */

import ApiService from './ApiService'

const ClientFilesService = {
	fetch(clientId) {
		return ApiService.get('client.files.index', { client: clientId })
	},

	download(clientId, fileId, fileName) {
		return ApiService.downloadFile('client.files.download', fileName, {
			client: clientId,
			file: fileId,
		})
	},

	downloadApiReport(clientId, reportId, fileName) {
		return ApiService.downloadFile('client.dnb_api_reports.download', fileName, {
			client: clientId,
			report: reportId,
		})
	},

	preview(clientId, fileId) {
		return ApiService.get('client.files.preview', { client: clientId, file: fileId })
	},

	delete(clientId, fileId) {
		return ApiService.delete('client.files.destroy', { client: clientId, file: fileId })
	},

	updateYearEnd(clientId, value) {
		return ApiService.patch(
			'client.financial_year_end.update',
			{ financial_year_end: value },
			{ client: clientId },
		)
	},
}

export default ClientFilesService
